// src/components/PostCard/index.jsx
import React from 'react';
import { Card, Typography, Tag, Space, Button } from 'antd';
import { 
  CalendarOutlined, 
  TagOutlined, 
  EyeOutlined,
  EditOutlined,
  DeleteOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './index.css';

const { Title, Paragraph, Text } = Typography;

const PostCard = ({ 
  post, 
  showActions = true,
  onDelete,
  compact = false,
  showSummary = true 
}) => {
  const {
    id,
    title,
    summary,
    content,
    tags = [],
    createdAt,
    viewCount = 0
  } = post;

  const handleDelete = (e) => {
    e.preventDefault();
    if (onDelete && window.confirm('确定要删除这篇文章吗？')) {
      onDelete(id);
    }
  };

  const truncatedContent = content && content.length > 150 
    ? content.substring(0, 150) + '...' 
    : content;

  return (
    <Card className={`post-card ${compact ? 'post-card-compact' : ''}`}>
      <div className="post-card-header">
        <Link to={`/post/${id}`} className="post-title-link">
          <Title level={compact ? 4 : 3} className="post-title">
            {title}
          </Title>
        </Link>
        
        <div className="post-meta">
          <Space size="small" wrap>
            <Text type="secondary" className="post-date">
              <CalendarOutlined /> {createdAt}
            </Text>
            
            {viewCount > 0 && (
              <>
                <Text type="secondary" className="post-views">
                  <EyeOutlined /> {viewCount}
                </Text>
              </>
            )}
          </Space>
        </div>
      </div>

      {showSummary && summary && (
        <Paragraph type="secondary" className="post-summary">
          {summary}
        </Paragraph>
      )}

      {!compact && content && (
        <Paragraph className="post-content-preview">
          {truncatedContent}
        </Paragraph>
      )}

      <div className="post-tags-container">
        <TagOutlined style={{ color: '#999', marginRight: 8 }} />
        <Space size={[0, 4]} wrap>
          {tags.map(tag => (
            <Tag 
              key={tag} 
              color="blue"
              className="post-tag"
              onClick={() => window.location.href = `/?tag=${tag}`}
            >
              {tag}
            </Tag>
          ))}
        </Space>
      </div>

      {showActions && (
        <div className="post-actions">
          <Space>
            <Link to={`/post/${id}`}>
              <Button type="link" size="small">阅读全文</Button>
            </Link>
            <Link to={`/write/${id}`}>
              <Button 
                type="text" 
                size="small"
                icon={<EditOutlined />}
              >
                编辑
              </Button>
            </Link>
            <Button 
              type="text" 
              danger 
              size="small"
              icon={<DeleteOutlined />}
              onClick={handleDelete}
            >
              删除
            </Button>
          </Space>
        </div>
      )}
    </Card>
  );
};

PostCard.propTypes = {
  post: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    summary: PropTypes.string,
    content: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    createdAt: PropTypes.string,
    viewCount: PropTypes.number
  }).isRequired,
  showActions: PropTypes.bool,
  onDelete: PropTypes.func,
  compact: PropTypes.bool,
  showSummary: PropTypes.bool
};

PostCard.defaultProps = {
  showActions: true,
  compact: false,
  showSummary: true
};

export default PostCard;